<template>
    <div class="marquee-container" :style="`background-color: ${backgroundColor}`">
        <p class="marquee-text">{{ text }}</p>
    </div>
</template>
  
<script>
import anime from 'animejs';

export default {
    name: "Marquee",
    props: {
        text: String,
        loop: Boolean,
        translateX: Array,
        easing: String,
        backgroundColor: String
    },
    data() {
        return {
            // isPaused: false, // Trạng thái dừng của hiệu ứng
            speed: 0
        };
    },
    created() {
        this.calculateSpeed();
    },
    mounted() {
        this.createMarqueeAnimation();
    },
    methods: {
        calculateSpeed() {
            if (window.innerWidth <= 425) {
                this.speed = 8000;
            } else if (window.innerWidth <= 768) {
                this.speed = 10000;
            } else if (window.innerWidth <= 1024) {
                this.speed = 20000;
            } else {
                this.speed = 40000;
            }
        },
        createMarqueeAnimation() {
            const textElement = document.querySelector('.marquee-text');
            const textWidth = textElement.offsetWidth;
            const containerWidth = textElement.parentElement.offsetWidth;
            var ratio = textWidth / containerWidth;
            const duration = ratio * this.speed;
            // console.log(parseFloat(this.translateX[0]))
            // this.translateX[0] = (parseFloat(this.translateX[0])/100 * ratio) + '%';
            // console.log(this.translateX)
            // if(scale > 1) {
            //     this.translateX = ['100%', '-100%']
            // }
            // const duration = scale * 25000; // Tính toán duration dựa trên tỷ lệ độ dài văn bản và chiều rộng của container

            var animation = anime({
                targets: '.marquee-text',
                translateX: this.translateX,
                duration: duration,
                loop: this.loop,
                // backgroundColor: this.backgroundColor,
                easing: this.easing,
            });

            textElement.addEventListener('mouseenter', () => {
                animation.pause(); // Tạm dừng từng hiệu ứng trong mảng
            });

            textElement.addEventListener('mouseleave', () => {
                animation.play(); // Tiếp tục chạy từng hiệu ứng trong mảng
            });
        },
    },
};
</script>
  
<style>
.marquee-container {
    color: white;
    width: 100%;
    padding-top: 5px;
    /* display: inline-flex; */
    font-weight: 600;
    overflow: hidden;
    /* z-index: 9999; */
}

.marquee-text {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    margin: unset;
}
</style>